import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { MetricCardComponent } from 'src/app/core/components/metric-card';
import { EmailAverageCoverageResponse } from 'src/app/core/models/analytics/es-models';

@Component({
  selector: 'app-es-average-coverage-card',
  standalone: true,
  imports: [CommonModule, MetricCardComponent],
  templateUrl: './es-average-coverage-card.component.html',
  styleUrl: './es-average-coverage-card.component.scss',
})
export class EsAverageCoverageCardComponent {
  emailAverageCoverage = input<EmailAverageCoverageResponse>();
}
